<template>
  <div :class="['mastery-footer-component', { mastery: isMasteryApp }]">
    <slot name="before-action" />
    <div class="buttons">
      <button
        v-if="primaryActionText && showBtn"
        class="primary-action"
        :disabled="disableBtn"
        @click="$emit('primary-action')"
      >
        {{ primaryActionText }}
      </button>
      <button
        v-if="secondaryActionText && showBtn"
        class="secondary-action"
        :disabled="disableBtn"
        @click="$emit('secondary-action')"
      >
        {{ secondaryActionText }}
      </button>
      <slot name="asset-tray-button" />
    </div>
    <slot name="after-action" />
  </div>
</template>

<script>
import GlobalMixin from '@/mixins/global';
export default {
  mixins: [GlobalMixin],
  props: {
    disableBtn: {
      type: Boolean,
      default: false,
    },
    primaryActionText: {
      type: String,
    },
    secondaryActionText: {
      type: String,
    },
    showBtn: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['primary-action', 'secondary-action'],
  computed: {
    isMasteryApp() {
      return this.$store.getters['app/isMasteryApp'];
    },
  },
};
</script>

<style lang="scss" scoped>
.mastery-footer-component {
  background: $white-1;
  border-top: 1px solid rgba(0,0,0,.12);
  bottom: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: rem-calc(44);
  left: rem-calc(220);
  padding: 0 !important;
  position: fixed;
  right: 0;
  transition: height 0.3s;
  z-index: 10;

  @include breakpoint(small) {
    left: 0;
    padding: 0 rem-calc(16);
  }

  &.mastery {
    left: rem-calc(88);

    @include breakpoint(small) {
      left: 0;
      bottom: rem-calc(72);
    }
  }

  .buttons {
    align-items: center;
    display: flex;
    max-width: rem-calc(600);
    width: 100%;
    pointer-events: none;
    margin: auto;
    position: absolute;
    left: 0;
    right: 0;
    top: rem-calc(-24);

    @include breakpoint(small) {
      justify-content: flex-end;
    }

    button {
      pointer-events: auto;
      margin-right: rem-calc(16);

      &.primary-action,
      &.secondary-action {
        border: 1px solid transparent;
        border-radius: rem-calc(24);
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
        font-size: rem-calc(14);
        font-weight: $semi-bold;
        height: rem-calc(48);
        letter-spacing: 0.5px;
        padding: 0 rem-calc(32);
        text-transform: uppercase;

        &:disabled {
          background: #9ad8c0;
        }
      }

      &.primary-action {
        background: #00b46d;
        color: #ffffff;
      }

      &.secondary-action {
        background: #ffffff;
        border-color: #00b46d;
        box-shadow: none;
        color: #00b46d;
      }
    }
  }
}
</style>
